import { render, staticRenderFns } from "./choose_me_intro.vue?vue&type=template&id=2ae442bc&scoped=true&"
import script from "./choose_me_intro.vue?vue&type=script&lang=js&"
export * from "./choose_me_intro.vue?vue&type=script&lang=js&"
import style0 from "./choose_me_intro.vue?vue&type=style&index=0&id=2ae442bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae442bc",
  null
  
)

export default component.exports